import Section from "../../components/section/section";
import RatingOverviewContext from "../../container/ratingOverview/context/ratingOverviewContext";
import RatingOverviewContainer from "../../container/ratingOverview/ratingOverviewContainer";

const RatingOverview = (): React.JSX.Element => (
  <Section>
    <RatingOverviewContext>
      <RatingOverviewContainer />
    </RatingOverviewContext>
  </Section>
);

export default RatingOverview;
